import { Component } from '@angular/core';
import { StudentDeduplicationService } from '../../service/student-deduplication.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'app-children-deduplication-summary',
    templateUrl: './children-deduplication-summary.component.html',
    styleUrls: ['./children-deduplication-summary.component.scss']
})
export class ChildrenDeduplicationSummaryComponent {
    regions: any[] = [];

    isLoading: boolean = false;

    // Table display
    columns = {
        Region: { INDEX: 1, ENABLED: true, SORT: 'CODE', DATA: 'CODE', DISABLED: false },

        Unresolved: { INDEX: 2, ENABLED: true, SORT: 'UNRESOLVED', DATA: 'UNRESOLVED', DISABLED: false },

        Resolved: { INDEX: 3, ENABLED: true, SORT: 'RESOLVED', DATA: 'RESOLVED', DISABLED: false }
    };

    displayedColumns: string[] = []; // Dynamically populated based on results + baseDisplayedColumns
    tableDataSource: MatTableDataSource<any>;

    promises: Array<any> = [];

    constructor(public studentDeduplicationService: StudentDeduplicationService) {}

    ngOnInit(): void {
        this.isLoading = true;

        // Permissions
        this.getDuplicatesCount();

        // Display columns
        this.displayedColumns = this.generateDisplayColumns();

        Promise.all(this.promises).then((res) => {
            this.updateDataSource();

            this.isLoading = false;
        });
    }

    getDuplicatesCount() {
        let deferred = new Promise((resolve, reject) => {
            this.studentDeduplicationService.getDuplicatesCount().subscribe((res) => {
                if (res.regions) {
                    this.regions = res.regions;
                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    generateDisplayColumns(prefixColumns?: string[]) {
        let displayedColumns: string[] = prefixColumns ? prefixColumns : [];
        let columns: any = this.columns;
        //displayedColumns = displayedColumns.concat(this.baseDisplayedColumns);

        const properties = Object.keys(columns);
        properties.forEach((property) => {
            if (columns[property].ENABLED) {
                displayedColumns.push(columns[property].SORT);
            }
        });

        return displayedColumns;
    }

    updateDataSource() {
        setTimeout(() => {
            this.tableDataSource = new MatTableDataSource<any>();

            // Data
            this.tableDataSource.data = this.regions.sort((n1: any, n2: any) => (n1.CODE! > n2.CODE! ? 1 : -1));
        }, 100);
    }
}
